import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";

export const saveEnterpriseIntakeFormRequest = async (formValues) => {
  const { data } = await axios({
    method: "post",
    url: `${getCloudFunctionUrl("saveEnterpriseIntakeForm")}/saveEnterpriseIntakeForm`,
    data: { formValues },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};
